import images from "./images";
import { useState, useEffect } from "react";
function ImageDisplay() {
  const [num, setNum] = useState(1);

  function start() {
    document.querySelectorAll(".product-display-thumbnail").forEach((item) => {
      item.classList.remove("product-display-thumbnail-acive");
      if (+item.id === num) {
        item.classList.add("product-display-thumbnail-acive");
      }
    });
  }
  useEffect(start);

  function handleNum(e) {
    setNum(+e.target.id);
    document.querySelectorAll(".product-display-thumbnail").forEach((item) => {
      item.classList.remove("product-display-thumbnail-acive");
    });
    e.target.classList.add("product-display-thumbnail-acive");
  }

  function increaseSlideshow() {
    start();
    setNum((prev) => {
      return prev < 4 ? prev + 1 : prev;
    });
  }
  function decreaseSlideshow() {
    start();
    setNum((prev) => {
      return prev > 1 ? prev - 1 : prev;
    });
  }

  function openExhibition() {
    if (window.screen.width > 768) {
      document.querySelector(".overlay").classList.add("overlay-open");
      document.querySelector(".product-exhibition").classList.remove("hidden");
    }
  }

  return (
    <div className="product-display">
      <img
        alt=""
        src={images[num - 1].img}
        className="product-display-large"
        onClick={openExhibition}
      />
      <div className="product-display-control">
        <img
          id={images[0].id}
          alt=""
          src={images[0].thumbnail}
          className="product-display-thumbnail"
          onClick={handleNum}
        />
        <img
          id={images[1].id}
          alt=""
          src={images[1].thumbnail}
          className="product-display-thumbnail"
          onClick={handleNum}
        />
        <img
          id={images[2].id}
          alt=""
          src={images[2].thumbnail}
          className="product-display-thumbnail"
          onClick={handleNum}
        />
        <img
          id={images[3].id}
          alt=""
          src={images[3].thumbnail}
          className="product-display-thumbnail"
          onClick={handleNum}
        />
      </div>
      <div className="slide-control">
        <div className="prev" onClick={decreaseSlideshow}>
          <svg width="12" height="18" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11 1 3 9l8 8"
              stroke="#1D2026"
              strokeWidth="3"
              fill="none"
              fillRule="evenodd"
            />
          </svg>
        </div>
        <div className="next" onClick={increaseSlideshow}>
          <svg width="12" height="18" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m2 1 8 8-8 8"
              stroke="#1D2026"
              strokeWidth="3"
              fill="none"
              fillRule="evenodd"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default ImageDisplay;
